import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import "./SelectButton";
import { GeneralSelect } from "../Custom-Forms/General-Select";
import Button from "react-bootstrap/Button";
import "./Profile.css";
import "react-toastify/dist/ReactToastify.css";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { GeneralRadioGroupInput } from "../Custom-Forms/General-Radio-Group-Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import { STATES } from "./util/states.js";
import prettyBytes from "pretty-bytes";

import {
    formateUploadDate,
    formatDateToInputFormat,
} from "./util/helpers.js";
import { FileUpload } from "../File-Upload/File-Upload";
import { FileUploadDelete } from "../File-Upload/File-Upload-Delete";

export const DriverLicense = () => {
    const { values, setValues, errors } = useFormikContext();
    const profile = useSelector(selectProfile);

    const [areDriverLicenseFieldsFilled, setAreDriverLicenseFieldsFilled] =
        useState(false);

    const [isEditing, setIsEditing] = useState(areDriverLicenseFieldsFilled);

    const driverLicenseClasses = [
        "Class A",
        "Class B",
        "Class C",
        "Class D",
        "Class M",
    ];
    const driverLicenseTypes = [
        "Standard License",
        "Commercial Driver’s License (CDL)",
        "Motorcycle License",
    ];

    const [uploadAddInfo3, setUploadAddInfo3] = useState(false);

    const checkDriverLicenseFieldsFilled = (values) => {
        if (values.hasDriverLicense === "No") {
            return true;
        }

        if (values.hasDriverLicense === "") {
            return false;
        }

        return (
            values.driverLicenseNumber &&
            values.driverLicenseClass &&
            values.driverLicenseState &&
            values.driverLicenseExpirationDate &&
            values.driverLicenseType
        );
    };

    useEffect(() => {
        setIsEditing(!areDriverLicenseFieldsFilled);
    }, [values.hasDriverLicense]);
    useEffect(() => {

        setIsEditing(Object.keys(errors).length === 0 );

    }, []);
    useEffect(() => {

        setAreDriverLicenseFieldsFilled(checkDriverLicenseFieldsFilled(values));
    }, [
        values.driverLicenseNumber,
        values.driverLicenseClass,
        values.driverLicenseType,
        values.driverLicenseState,
        values.driverLicenseExpirationDate,
        values.hasDriverLicense,
    ]);

    return (
        <>
            <Container className="container2 px-3 pb-3">
                <Row className="  rounded-top-3 mx-auto mx-0 px-0 ">
                    {areDriverLicenseFieldsFilled && (
                        <>
                            <div
                                className="alert alert-success text-center success-msg animate__animated animate__fadeInUp mt-2 mb-0"
                                role="alert"
                            >
                                <h4 className="alert-heading fw-bold fs-5 fs-md-4">
                                    <FontAwesomeIcon
                                        icon={faCheck}
                                        style={{
                                            color: "cornflowerblue",
                                            fontSize: "1.3em",
                                        }}
                                        className="fa-fw fa-xs d-md-inline-block me-md-2 pt-1"
                                    />
                                </h4>
                                Great! You can proceed to the next step.
                            </div>
                        </>
                    )}


                </Row>

                {
                    <>
                        <Row className="d-flex justify-content-center">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    Would you like to include your Driver
                                    License details?
                                </label>
                            </Col>
                        </Row>
                        {values.hasDriverLicense === "" && (
                            <>
                                <Row className="d-flex justify-content-center ">
                                    <p className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                        Please Make a Selection
                                    </p>
                                </Row>
                            </>
                        )}
                        <Col className="d-flex justify-content-center">
                            <GeneralRadioGroupInput
                                name="hasDriverLicense"
                                onChange={(e) => {
                                    setValues((prevValues) => ({
                                        ...prevValues,
                                        hasDriverLicense: e.target.value,
                                        ...(e.target.value === "No" && {
                                            driverLicenseNumber: "",
                                            driverLicenseClass: "",
                                            driverLicenseType: "",
                                            driverLicenseState: "",
                                            driverLicenseExpirationDate: "",
                                        }),
                                    }));
                                }}
                            />
                        </Col>
                    </>
                }
                {values.hasDriverLicense === "Yes" && (
                        <>
                            <Card
                                style={{ padding: 0 }}
                                className="full-width-card"
                            >
                                <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                    <h3 className="header-font"><span>Driver License Info</span></h3>

                                    <Button
                                        className="transparent-btn me-2 position-absolute end-0"
                                        onClick={async () => {
                                            let result = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "You won't be able to revert this!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText:
                                                    "Yes, delete it!",
                                            });

                                            if (result.isConfirmed) {
                                                let valuesCopy = {
                                                    ...values,
                                                };
                                                valuesCopy.driverLicenseNumber =
                                                    "";
                                                valuesCopy.driverLicenseClass =
                                                    "";
                                                valuesCopy.driverLicenseType =
                                                    "";
                                                valuesCopy.driverLicenseState =
                                                    "";
                                                valuesCopy.driverLicenseExpirationDate =
                                                    "";
                                                valuesCopy.hasDriverLicense =
                                                    "No";

                                                setValues(valuesCopy);
                                            }
                                        }}
                                    >
                                        <FaTrashAlt
                                            className="icon trash-icon"
                                            style={{ fontSize: "20px" }}
                                        />
                                    </Button>
                                </Card.Header>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Driver License Number
                                        </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="driverLicenseNumber"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Driver License Class
                                        </label>
                                        <GeneralSelect name="driverLicenseClass">
                                            <option value="">Select One</option>
                                            {driverLicenseClasses.map(
                                                (item) => {
                                                    return (
                                                        <option
                                                            key={item}
                                                            value={item}
                                                        >
                                                            {item}
                                                        </option>
                                                    );
                                                },
                                            )}
                                        </GeneralSelect>
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Driver License Type
                                        </label>
                                        <GeneralSelect name="driverLicenseType">
                                            <option value="">Select One</option>
                                            {driverLicenseTypes.map((item) => {
                                                return (
                                                    <option
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </option>
                                                );
                                            })}
                                        </GeneralSelect>
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Driver License State
                                        </label>
                                        <GeneralSelect name="driverLicenseState">
                                            <option value="">Select One</option>
                                            {STATES.map((item) => {
                                                return (
                                                    <option
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </option>
                                                );
                                            })}
                                        </GeneralSelect>
                                    </Col>
                                </Row>

                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4 mb-5">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Driver License Expiration Date
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control "
                                            type="date"
                                            name="driverLicenseExpirationDate"
                                            placeholder="MM/DD/YYYY"
                                            value={formatDateToInputFormat(
                                                values.driverLicenseExpirationDate,
                                            )}
                                        />
                                    </Col>
                                </Row>
                        <Card.Header
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <h4 className="border-bottom border-warning border-5">
                                Upload Driver&apos;s License
                            </h4>
                        </Card.Header>
                        <Card.Body>
                            {profile.Additional_Info_Field_3In === "Yes" && (
                                <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                    <Col className="py-3">
                                        <Row>
                                            <Col className="text-center">
                                                <h5 className="border-bottom border-warning border-5">
                                                    {" "}
                                                    Current Driver&apos;s License on File:
                                                </h5>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>File Name:</b>{" "}
                                                {
                                                    profile.Additional_Info_Field_3_OriginalName
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>Upload Date:</b>{" "}
                                                {formateUploadDate(
                                                    profile.Additional_Info_Field_3_UploadDate,
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b>Size:</b>{" "}
                                                {profile.Additional_Info_Field_3_FileSize
                                                    ? prettyBytes(
                                                        parseInt(
                                                            profile.Additional_Info_Field_3_FileSize,
                                                        ),
                                                    )
                                                    : ""}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <FileUploadDelete
                                                containerName={
                                                    "Additional_Info_Field_3"
                                                }
                                                fileName={
                                                    profile.Additional_Info_Field_3_OriginalName
                                                }
                                            />
                                        </Row>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                        {uploadAddInfo3 && (
                            <FileUpload
                                containerName={"Additional_Info_Field_3"}
                            />
                        )}
                        {profile.Additional_Info_Field_3In === "No" &&
                            !uploadAddInfo3 && (
                                <Col className="d-flex justify-content-center mb-4">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadAddInfo3 ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadAddInfo3(!uploadAddInfo3)
                                        }
                                    >
                                        {uploadAddInfo3
                                            ? "Cancel"
                                            : "Upload New Driver's License"}
                                    </Button>
                                </Col>
                            )}
                            </Card>
                        </>
                    )}

                {values.hasDriverLicense === "No" && (
                    <>
                        <Row className="d-flex justify-content-center ">
                            <p className="text-danger w-auto fst-italic fw-bold text-center success-msg">
                                * Some positions within the Navajo Nation might
                                necessitate the possession of a valid
                                driver&apos;s license.
                                <br /> Please carefully read the job description
                                for the role you&apos;re interested in.
                            </p>
                        </Row>
                    </>
                )}
            </Container>
        </>
    );
};
